import React from 'react'
import styled from 'styled-components'

const Table = styled.table`
    margin: 0 16px;
    table-layout: fixed;
    margin-bottom: 20px;
`

const TR = styled.tr`
    border-bottom: 1px whitesmoke solid;
`

const TD = styled.td`
    word-wrap:break-word;
    padding-right: 8px;
`

const TDshort = styled.td`
    word-wrap:break-word;
    padding-right: 8px;
`

function sortTechSpecs(ts1, ts2) {
    if (ts1.sequence > ts2.sequence) {
        return 1;
    } else if (ts1.sequence < ts2.sequence) {
        return -1;
    } else {
        return ts1.name.localeCompare(ts2.name);
    }
}

export default function TechSpecs(props) {
    const { itemDetails } = props

    const TechSpecItems = itemDetails?.itemTechSpecs?.sort(sortTechSpecs).map((elem, idx) => (
        <TR key={idx}>
            <TDshort>{elem.name}</TDshort>
            <TD dangerouslySetInnerHTML={{ __html: elem.value }}></TD>
        </TR>
    ))

    return (
        <>
            {!!TechSpecItems.length && (
                <>
                    <h2 id='techspec'>Tech Specifications</h2>
                    <Table>
                        <tbody>{TechSpecItems}</tbody>
                    </Table>
                </>
            )
            }
        </>
    )

}
